import { EntityDto } from '../dto/entityDto'
import http from '../httpService'
import { notifySuccess } from '../../lib/helper'
import { LNotification } from '../../lib/abpUtility'
import { WfTrackerModel } from '@models/workflow/wfTrackerModel'

class WfTrackerService {
  public async create(createStatusInput) {
    const res = await http.post('api/services/app/WorkflowTracker/Create', createStatusInput)
    notifySuccess(LNotification('SUCCESS'), LNotification('SAVING_SUCCESSFULLY'))
    return WfTrackerModel.assign(res.data.result)
  }

  public async update(updateStatusInput) {
    const res = await http.put('api/services/app/WorkflowTracker/Update', updateStatusInput)
    notifySuccess(LNotification('SUCCESS'), LNotification('SAVING_SUCCESSFULLY'))
    return WfTrackerModel.assign(res.data.result)
  }

  public async updateSortList(body: any) {
    const res = await http.post('/api/services/app/WorkflowTracker/Sort', body)
    notifySuccess(LNotification('SUCCESS'), LNotification('SAVING_SUCCESSFULLY'))
    return res.data.result
  }

  public async delete(entityDto: EntityDto) {
    const res = await http.delete('api/services/app/WorkflowTracker/Delete', { params: entityDto })
    return res.data
  }

  public async activateOrDeactivate(id: number, isActive) {
    const res = await http.post('api/services/app/WorkflowTracker/Active', null, { params: { id, isActive } })
    notifySuccess(LNotification('SUCCESS'), LNotification('SAVING_SUCCESSFULLY'))
    return res.data
  }

  public async changeStatus(changeStatusInput) {
    const res = await http.post('api/services/app/WorkflowTracker/ChangeLanguage', changeStatusInput)
    return res.data
  }

  public async get(params): Promise<any> {
    const res = await http.get('api/services/app/WorkflowTracker/GetForEdit', { params })
    return WfTrackerModel.assign(res.data.result)
  }

  public async filter(pagedFilterAndSortedRequest): Promise<any> {
    const res = await http.get('api/services/app/WorkflowTracker/GetAll', { params: pagedFilterAndSortedRequest })
    const result = res.data.result
    result.items = WfTrackerModel.assigns(result.items)
    return result
  }

  public async getAll(params): Promise<any> {
    const result = await http.get('api/services/app/WorkflowTracker/GetList', { params })
    return WfTrackerModel.assigns(result.data.result)
  }
}

export default new WfTrackerService()
